export const movementTab = {
  title: 'Movimentações',
  endpoint: 'movements',
}

export const barcodeTab = {
  title: 'Código de Barras',
  endpoint: 'barcodes',
}

export const reservesTab = {
  title: 'Reservas',
  endpoint: 'reserves',
}

export const movementsByTypeTab = {
  title: 'Histórico de Compras/Vendas',
  endpoint: 'movements-by-type',
}

export const tabs = [movementTab, barcodeTab, reservesTab, movementsByTypeTab]
